import React from "react";
import { useTable } from "../../Components/useTable";

const TagsList = () => {
  const type = "Live Stream Tags";
  const headCells = [
    { id: "tagName", numeric: false, label: "Name" },
    { id: "picture", numeric: false, label: "Image" },
    { id: "sortOrder", numeric: false, label: "Sort Order" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default TagsList;
